import { PromptLibraryTab } from "@/modules/promptLibrary/promptLibrary.types";

export const createGetItemsPayload = (searchPhrase: string, activeTab: PromptLibraryTab) => ({
  ...(searchPhrase ? { search: searchPhrase } : {}),
  ...(activeTab === "own" ? { own: true } : {}),
  ...(activeTab === "favourite" ? { favorite: true } : {}),
});
